export function initGoogleAnalytics(trackingId: string): void {
	// Vérifie si le script gtag existe déjà
	if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${trackingId}"]`)) {
		console.warn(`Google Analytics déjà initialisé avec l'ID ${trackingId}`);
		return;
	}

	// Script gtag.js, bloqué par Cookiebot tant que le consentement "statistics" n'est pas donné
	const gtagScript: HTMLScriptElement = document.createElement('script');
	gtagScript.async = true;
	gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
	gtagScript.type = 'text/plain';
	gtagScript.setAttribute('data-cookieconsent', 'statistics');
	document.head.appendChild(gtagScript);

	// Script de configuration, bloqué par Cookiebot tant que le consentement "statistics" n'est pas donné
	const configScript: HTMLScriptElement = document.createElement('script');
	configScript.type = 'text/plain';
	configScript.setAttribute('data-cookieconsent', 'statistics');
	configScript.text = `
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		window.gtag = gtag;
		gtag('js', new Date());
		gtag('config', '${trackingId}');
	`;
	document.head.appendChild(configScript);

	console.info(`Google Analytics initialisé avec l'ID ${trackingId}`);
}
